/* ==========================================================================
   NGA — Product page

   Variant selection, live price/availability, media sync, add to cart,
   and the sticky mobile buy bar.

   Variant data is read from the product JSON Shopify already renders, so
   there is no extra request and no drift between what is shown and what is
   actually purchasable.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    if (cents == null) return '';
    var n = Number(cents);
    if (isNaN(n)) return '';
    if (window.Shopify && window.Shopify.formatMoney && window.NGA_MONEY_FORMAT) {
      try { return window.Shopify.formatMoney(n, window.NGA_MONEY_FORMAT); } catch (e) {}
    }
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  class NgaProduct extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-nga-product-json]');
      if (!dataEl) return;

      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      this.form = this.querySelector('form[action*="/cart/add"]');
      this.idInput = this.querySelector('[data-nga-variant-id]');
      this.priceEl = this.querySelector('[data-nga-price]');
      this.stockEl = this.querySelector('[data-nga-stock]');
      this.atcEl = this.querySelector('[data-nga-atc]');
      this.skuEl = this.querySelector('[data-nga-sku]');
      this.optionEls = Array.prototype.slice.call(this.querySelectorAll('[data-nga-option]'));
      this.notifyEl = this.querySelector('[data-nga-notify]');

      this.strings = {};
      try { this.strings = JSON.parse(this.getAttribute('data-strings') || '{}'); } catch (e) {}

      this.lowStockAt = parseInt(this.getAttribute('data-low-stock'), 10) || 0;

      this.selected = {};
      this.optionEls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10);
        var active = el.querySelector('[aria-checked="true"], .is-active');
        if (active) this.selected[idx] = active.getAttribute('data-value');
      }, this);

      this.bind();
      this.update();
      this.initSticky();
    }

    str(k, fb) { var v = this.strings[k]; return (v == null || v === '') ? (fb || '') : v; }

    bind() {
      var self = this;

      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-nga-option] [data-value]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        var group = btn.closest('[data-nga-option]');
        var idx = parseInt(group.getAttribute('data-option-index'), 10);

        group.querySelectorAll('[data-value]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');

        self.selected[idx] = btn.getAttribute('data-value');
        self.update();
      });

      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          // Let Shopify handle it when the cart is a page, intercept for the drawer.
          if (!self.atcEl || self.atcEl.disabled) return;
          e.preventDefault();
          self.addToCart();
        });
      }
    }

    currentVariant() {
      var self = this;
      var keys = Object.keys(this.selected);
      return this.data.variants.find(function (v) {
        return keys.every(function (k) { return v.options[k] === self.selected[k]; });
      }) || null;
    }

    /* Grey out option values that cannot combine with the current choice. */
    refreshAvailability() {
      var self = this;
      this.optionEls.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var possible = self.data.variants.some(function (v) {
            if (v.options[idx] !== val) return false;
            // Every *other* chosen option must still match.
            return Object.keys(self.selected).every(function (k) {
              var ki = parseInt(k, 10);
              if (ki === idx) return true;
              return v.options[ki] === self.selected[ki];
            }) && v.available;
          });
          btn.classList.toggle('is-out', !possible);
          btn.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      });
    }

    update() {
      var v = this.currentVariant();
      this.refreshAvailability();

      if (this.idInput) this.idInput.value = v ? v.id : '';
      if (this.skuEl) { this.skuEl.textContent = v && v.sku ? v.sku : ''; }

      if (this.priceEl) {
        if (v) {
          var html = money(v.price);
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html += '<s>' + money(v.compare_at_price) + '</s>';
          }
          this.priceEl.innerHTML = html;
        }
      }

      if (this.stockEl) {
        var cls = 'nga-buy__stock', txt = '';
        if (!v) {
          cls += ' nga-buy__stock--out';
          txt = this.str('unavailable', 'Unavailable');
        } else if (!v.available) {
          cls += ' nga-buy__stock--out';
          txt = this.str('soldOut', 'Sold out');
        } else if (this.lowStockAt > 0 && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= this.lowStockAt) {
          cls += ' nga-buy__stock--low';
          txt = this.str('lowStock', 'Only a few left').replace('[count]', v.inventory_quantity);
        } else {
          cls += ' nga-buy__stock--in';
          txt = this.str('inStock', 'In stock, ready to ship');
        }
        this.stockEl.className = cls;
        this.stockEl.innerHTML = '<i></i><span>' + esc(txt) + '</span>';
      }

      if (this.atcEl) {
        if (!v) {
          this.atcEl.disabled = true;
          this.atcEl.textContent = this.str('unavailable', 'Unavailable');
        } else if (!v.available) {
          this.atcEl.disabled = true;
          this.atcEl.textContent = this.str('soldOut', 'Sold out');
        } else {
          this.atcEl.disabled = false;
          // Carrying the price on the button removes a glance back up the page.
          var label = this.str('addToCart', 'Add to bag');
          if (this.getAttribute('data-price-in-button') === 'true') {
            label += ' — ' + money(v.price);
          }
          this.atcEl.textContent = label;
        }
      }

      // Back in stock: offered only when this exact variant cannot be bought.
      // Same pass as the button above, so the two can never disagree.
      if (this.notifyEl) {
        var posted = !!this.notifyEl.querySelector('.nga-notify__msg.is-ok');
        var unavailable = !v || !v.available;
        this.notifyEl.hidden = posted ? false : !unavailable;
        if (unavailable) {
          var vLabel = (v && v.options && v.options.length) ? v.options.join(' / ') : '';
          this.notifyEl.setAttribute('data-variant-title', vLabel);
          this.notifyEl.setAttribute('data-variant-id', v ? String(v.id) : '');
          this.notifyEl.setAttribute('data-variant-sku', (v && v.sku) ? v.sku : '');
          this.notifyEl.dispatchEvent(new CustomEvent('nga:notify:sync'));
        } else {
          // Collapse the form so it does not reopen already filled in.
          var openForm = this.notifyEl.querySelector('[data-nga-notify-form]');
          var openBtn = this.notifyEl.querySelector('[data-nga-notify-open]');
          if (openForm) openForm.hidden = true;
          if (openBtn) openBtn.hidden = false;
        }
      }

      // Swap the gallery to this variant's image.
      if (v && v.featured_media && v.featured_media.id) {
        document.dispatchEvent(new CustomEvent('nga:variant:change', {
          detail: { mediaId: v.featured_media.id, variant: v }
        }));
      }

      // Keep the URL shareable without adding history entries.
      if (v && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      this.syncSticky(v);
    }

    addToCart() {
      var self = this;
      var v = this.currentVariant();
      if (!v || !v.available) return;

      var qtyInput = this.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var label = this.atcEl.textContent;

      this.atcEl.disabled = true;
      this.atcEl.textContent = this.str('adding', 'Adding…');

      var body = { items: [{ id: v.id, quantity: qty }] };

      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add');
          self.atcEl.textContent = self.str('added', 'Added to bag');
          if (window.NGA && window.NGA.refreshCartCount) window.NGA.refreshCartCount();
          if (window.NGA && window.NGA.toast) {
            window.NGA.toast(self.str('addedToast', 'Added to your bag.') + ' <a href="/cart">' + self.str('viewBag', 'View bag') + '</a>', { variant: 'pink' });
          }
          document.dispatchEvent(new CustomEvent('nga:cart:updated'));
          setTimeout(function () { self.atcEl.textContent = label; self.atcEl.disabled = false; }, 1800);
        })
        .catch(function (err) {
          self.atcEl.textContent = label;
          self.atcEl.disabled = false;
          if (window.NGA && window.NGA.toast) window.NGA.toast(esc(err.message));
        });
    }

    /* ---- Sticky mobile buy bar ---- */
    initSticky() {
      var bar = document.querySelector('[data-nga-stickybuy]');
      if (!bar) return;
      this.bar = bar;

      // update() runs before this, so the first syncSticky was a no-op and the
      // bar kept its Liquid-rendered "Add to bag" while the real button already
      // said Sold out. Sync once the bar is known.
      this.syncSticky(this.currentVariant());

      var anchor = this.querySelector('[data-nga-atc]');
      if (!anchor || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // Show the bar only once the real button has scrolled away.
          bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(anchor);

      var self = this;
      bar.addEventListener('click', function (e) {
        if (e.target.closest('[data-nga-sticky-add]')) {
          e.preventDefault();
          var v = self.currentVariant();
          if (!v || !v.available) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          self.addToCart();
        }
      });
    }

    syncSticky(v) {
      if (!this.bar) return;
      var p = this.bar.querySelector('[data-nga-sticky-price]');
      var b = this.bar.querySelector('[data-nga-sticky-add]');
      if (p && v) p.textContent = money(v.price);
      if (b) {
        b.disabled = !(v && v.available);
        b.textContent = (v && v.available) ? this.str('addToCart', 'Add to bag') : this.str('soldOut', 'Sold out');
      }
    }
  }

  if (!customElements.get('nga-product')) customElements.define('nga-product', NgaProduct);

  /* ---------------------------------------------------------------------
     Quantity stepper
     --------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nga-qty]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-nga-qty-wrap]');
    var input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var step = parseInt(input.step, 10) || 1;
    var val = parseInt(input.value, 10) || min;
    val += btn.getAttribute('data-nga-qty') === 'up' ? step : -step;
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

/* ==========================================================================
   Back in stock — "Notify me"
   --------------------------------------------------------------------------
   Asked for on NOTES ON WEBSITE V1, p13.

   The submit itself is Shopify's own contact form — a scripted POST to
   /contact is answered with a 403 bot challenge and never delivers, so this
   script does not send anything. It only reveals the form and writes the exact
   size and SKU into the message body, so the request that lands in the store
   inbox says which variant to restock.
   ========================================================================== */
(function () {
  function init(root) {
    var openBtn = root.querySelector('[data-nga-notify-open]');
    var panel = root.querySelector('[data-nga-notify-form]');
    var lead = root.querySelector('[data-nga-notify-lead]');
    var bodyField = root.querySelector('[data-nga-notify-body]');
    var input = panel && panel.querySelector('input[type="email"]');
    if (!openBtn || !panel || !input) return;

    function variantLabel() {
      var t = root.getAttribute('data-variant-title') || '';
      return (t && t !== 'Default Title') ? t : '';
    }

    function syncBody() {
      if (!bodyField) return;
      var base = bodyField.getAttribute('value') || '';
      // Keep the server-rendered product line, replace anything appended before.
      base = base.split(' | Size:')[0];
      var v = variantLabel();
      var sku = root.getAttribute('data-variant-sku') || '';
      var extra = '';
      if (v) extra += ' | Size: ' + v;
      if (sku) extra += ' | SKU: ' + sku;
      bodyField.value = base + extra;
    }

    openBtn.addEventListener('click', function () {
      openBtn.hidden = true;
      panel.hidden = false;
      syncBody();
      if (lead) {
        var v = variantLabel();
        lead.textContent = v
          ? 'Tell us where to reach you and we will email you when ' + v + ' is back.'
          : 'Tell us where to reach you and we will email you when this is back.';
      }
      input.focus();
    });

    // The size can change while the form is open.
    root.addEventListener('nga:notify:sync', syncBody);
    document.addEventListener('nga:variant:change', syncBody);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nga-notify]'), function (root) {
      // Shopify redirects back here after a successful send; the confirmation
      // is rendered inside a block that starts hidden.
      if (root.querySelector('.nga-notify__msg.is-ok')) {
        root.hidden = false;
        root.scrollIntoView({ block: 'center' });
        return;
      }
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
